<script setup>
defineProps({
  isShown: Boolean,
});
</script>

<template>
  <div>
    <transition leave-active-class="transition ease-in duration-1000" leave-from-class="opacity-100" leave-to-class="opacity-0">
      <div v-show="isShown" class="text-sm text-green-600">
        <slot />
      </div>
    </transition>
  </div>
</template>
